import { render, staticRenderFns } from "./ExpansibleAlert.vue?vue&type=template&id=1ba88ffb&scoped=true"
import script from "./ExpansibleAlert.vue?vue&type=script&lang=js"
export * from "./ExpansibleAlert.vue?vue&type=script&lang=js"
import style0 from "./ExpansibleAlert.vue?vue&type=style&index=0&id=1ba88ffb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba88ffb",
  null
  
)

export default component.exports